<template>
  <v-container fluid class="mt-3 mb-5 ml-2" style="margin: 0 auto">
    <v-row class="d-flex justify-space-between ma-0">
        <v-col cols="8" class="d-flex align-center d-xs-block">
            <v-btn
                elevation="0"
                fab
                color="transparent"
                class="mr-4"
                @click.stop="exitForm(true)">
                <v-icon>$exitform</v-icon>
            </v-btn>
            <h1 class="h1-font text-no-wrap text-truncate">Accesorio vehiculo</h1>
        </v-col>
        <v-col cols="4" class="d-flex justify-end align-center d-xs-block">
            <v-btn
                elevation="0"
                class="mr-9 my-4 btn-send__custom"
                @click="askIfSaveAccessory"
                >GUARDAR CAMBIOS</v-btn>
        </v-col>
    </v-row>
    <v-dialog v-model="alertExitForm" max-width="450px">
      <AlertExitForm
        @confirmExit="confirmExit"
      >
      </AlertExitForm>
    </v-dialog>
    <v-dialog v-model="confirmModal" width="550">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <h1
            style="font-family: 'NouvelR';letter-spacing: 0.01em;font-size: 22px;"
            class="font-weight-bold mt-4 mb-10 black--text"
            >¿Desea confirmar los cambios en el accesorio {{ accessorySelected.name }}?</h1>
          <p
            style="font-family: 'NouvelR';letter-spacing: 0.01em;font-size: 18px;"
            class="black--text"
            >Descripción: {{ accessorySelected.description }}</p>
          <p
            style="font-family: 'NouvelR';letter-spacing: 0.01em;font-size: 18px;"
            class="black--text"
            >Valor: ${{ accessorySelected.value }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            style="font-size: 12px;"
            class="mr-3"
            text
            @click="cancelSaveAccessory"
            >Cancelar</v-btn>
          <v-btn
            style="background: rgba(245, 245, 247, 0.5);border: 1px solid #000000;font-size: 12px;"
            class="bor-btn rounded mr-5 mt-2 mb-3 black--text"
            elevation="0"
            width="100"
            height="34"
            @click="saveAccessory"
            >Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import AlertExitForm from '@/components/layout/alerts/AlertExitForm'
import { mapGetters } from 'vuex'

export default {
  name: 'AddOrEditAccessoryHeader',
  components: {
    AlertExitForm
  },
  props: {
    accessorySelected: Object
  },
  data () {
    return {
      confirmModal: false
    }
  },
  computed: {
    ...mapGetters(['alertExitForm', 'editignAccessory'])
  },
  methods: {
    exitForm (val) {
      this.$emit('setValueFilterWhenCancel')
      this.$store.dispatch('handleExitForm', val)
    },
    confirmExit () {
      this.$store.dispatch('handleEditAccessory', false)
      this.$emit('exitEditing')
    },
    askIfSaveAccessory () {
      this.confirmModal = true
      // this.$emit('modelsToAccessoriesSelected')
    },
    cancelSaveAccessory () {
      this.confirmModal = false
    },
    saveAccessory () {
      if (this.editignAccessory) {
        this.$emit('editAccessory')
      } else {
        this.$emit('createNewAccessory')
      }
      this.confirmModal = false
    }
  }
}
</script>

<style lang="scss" scoped>
.h1-font {
  @include fontStyle(bold, 22px, 0.01em, $black)
}
@media (max-width: 400px) {
  .h1-font {
    font-size: 18px;
  }
}
::v-deep {
  .btn-send__custom {
        font-size: 10px;
        letter-spacing: 0.01em;
        border: 1px solid $black !important;
        background-color: #e9e9eb !important;
    }
}
</style>
